import { analytics } from 'analytics'
import { featureFlags } from './featureFlags'
import { FeatureFlagResponse } from './types'

export const featureFlagQueryKey = 'featureFlags'

export const triggerSplitTest = (data: FeatureFlagResponse) => {
  const networkFlags = data?.data?.feature_flags || []

  featureFlags.forEach((flag) => {
    if (!flag.enabled || flag.isStatic || !flag.test?.length) return

    const flagExists = !!networkFlags.includes(flag.name)

    analytics.events.splitTestTriggered({
      name: flag.test,
      cohort: flagExists ? 'test' : 'control',
    })
  })
}
